module.exports = __webpack_public_path__ + "img/eso-empty.5aceeeb0.svg";